export { default as DatePicker } from './date-picker';
import { withControlledFormComponentValue } from '../../with-controlled-form-component-value';
import DatePicker from './date-picker';

// make it default export with 'ditto_uim_jsm_duedate_field_support' cleanup
export const ControlledDatePicker = withControlledFormComponentValue((_field: string, value: string) => value)(
    DatePicker
);
